import Swiper, { Navigation, Autoplay } from 'swiper'

const Slider = () => {
  window.addEventListener("load", () => {
    setTimeout(() => {
      const swiper = new Swiper('.slider_slider_component', {
        modules: [Autoplay, Navigation],

        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
        },

        navigation: {
          nextEl: '.slider-button-next',
          prevEl: '.slider-button-prev',
        },
      })
    }, 2000)
  })
}

export default Slider
